import React from 'react';
import { Text, Switch, Input } from '../';

/**
 * AuctionFormFields Component
 * Auction switch and date/time fields for supplier add/edit car form
 * Goes under "מחיר ופרטים נוספים" section
 */
const AuctionFormFields = ({ 
  isAuction, 
  auctionStartDate, 
  auctionStartTime,
  onAuctionToggle,
  onAuctionDateChange,
  onAuctionTimeChange,
  errors = {}
}) => {

  return (
    <div className="mx-auto flex w-full max-w-[560px] flex-col gap-3 border-y border-gray-200 py-4">
      <div className="flex items-center justify-between gap-4">
        <button
          type="button"
          onClick={onAuctionToggle}
          className="flex min-w-0 cursor-pointer flex-col gap-1 text-right"
        >
          <span className="text-[15px] font-semibold text-black-900">העלאה כמכרז</span>
          <span className="text-[13px] leading-5 text-gray-600">פתיחת הצעות מחיר לפי תאריך ושעה</span>
        </button>
        <Switch
          value={isAuction}
          onCheckedChange={onAuctionToggle}
          className="shrink-0"
        />
      </div>

      {isAuction && (
        <div className="flex flex-col gap-3 pt-1">
          <div className="grid grid-cols-2 gap-3 md:grid-cols-1">
            <div className="flex min-w-0 flex-col gap-1.5">
              <label className="text-[13px] font-medium text-gray-700">
                תאריך התחלה <span className="text-red-600">*</span>
              </label>
              <Input
                type="date"
                value={auctionStartDate || ''}
                onChange={(e) => onAuctionDateChange(e.target.value)}
                className={`h-[42px] rounded-md border bg-white px-3 text-[14px] ${
                  errors.auctionStartDate ? 'border-red-400' : 'border-gray-300'
                }`}
              />
              {errors.auctionStartDate && (
                <Text size="textxs" className="!text-red-600">
                  {errors.auctionStartDate}
                </Text>
              )}
            </div>

            <div className="flex min-w-0 flex-col gap-1.5">
              <label className="text-[13px] font-medium text-gray-700">
                שעת התחלה <span className="text-red-600">*</span>
              </label>
              <Input
                type="time"
                value={auctionStartTime || ''}
                onChange={(e) => onAuctionTimeChange(e.target.value)}
                className={`h-[42px] rounded-md border bg-white px-3 text-[14px] ${
                  errors.auctionStartTime ? 'border-red-400' : 'border-gray-300'
                }`}
              />
              {errors.auctionStartTime && (
                <Text size="textxs" className="!text-red-600">
                  {errors.auctionStartTime}
                </Text>
              )}
            </div>
          </div>

          {(errors.auctionStartDate || errors.auctionStartTime) && (
            <div className="rounded-md border border-red-100 bg-red-50 px-3 py-2">
              <Text size="textmd" className="!text-red-700">
                יש לבחור תאריך ושעת התחלה למכרז
              </Text>
            </div>
          )}

          <div className="rounded-md bg-gray-50 px-3 py-2">
            <Text size="textmd" as="p" className="!text-gray-600">
              המכרז יתחיל במועד שנבחר. כל הצעה חדשה מאריכה אותו ב-5 דקות.
            </Text>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuctionFormFields;
